import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { ISanityHeading } from '../../fragments/sanity-heading-parts';

interface IHeadingProps {
  heading: ISanityHeading;
}

function Heading({ heading }: IHeadingProps): React.ReactElement {
  return (
    <div className="bg-secondary">
      <h2 className="relative flex flex-col items-center justify-center pt-24 pb-12">
        {/* <div className="absolute z-10">
          {heading.largeRibbon ? (
            <StaticImage
              src="../../images/ribbon-faqs.png"
              alt="header background"
              height={50}
            />
          ) : (
            <StaticImage
              src="../../images/ribbon.png"
              alt="header background"
            />
          )}
        </div> */}
        <span className="font-serif text-3xl text-center md:text-4xl text-highlight-ochre">
          {heading.headingTitle}
        </span>
      </h2>
    </div>
  );
}

export { Heading };
